module.exports = __webpack_public_path__ + "a21557dbaec7ff2d88c4be69d27d9430.fbx";